import { DELETE_BOOK_PUBLISHER } from "../../types/BookPublisherType";
import axios from "axios";

const deleteBookPublisher = (id) => {
	return {
		type: DELETE_BOOK_PUBLISHER,
		payload: id,
	};
};

export const DeleteBookPublisher = (id) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			await axios({
				method: "patch",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `book-publisher/${id}`,
				data: {
					status: false,
				},
			});
			//dispatching data
			dispatch(deleteBookPublisher(id));
		} catch (error) {
			console.log(error.message);
		}
	};
};
